import { createSlice } from "@reduxjs/toolkit";
import { getAllActivityLogs, getAllActivityLogsByCertificate, getAllActivityLogsByUser } from "./activityLogService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {

  activityLogList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
    pageCount: 0,
  },

  activityLogListByUser: {
    status: STATUS.IDLE,
    error: null,
    data: [],
    pageCount: 0,
  },
  
  activityLogListByCertificate: {
    status: STATUS.IDLE,
    error: null,
    data: [],
    pageCount: 0,
  },
};

/* -------------------- Slice -------------------- */

const activityLogSlice = createSlice({
  name: "activityLog",
  initialState,
  reducers: {
        clearActivityLogs: (state) => {
      state.activityLogList = {
        status: STATUS.IDLE,
        error: null,
        data: [],
        pageCount: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllActivityLogs.pending, (state) => {
        state.activityLogList.status = STATUS.LOADING;
        state.activityLogList.error = null;
        state.activityLogList.data = [];
      })
      .addCase(getAllActivityLogs.fulfilled, (state, action) => {
        state.activityLogList.status = STATUS.SUCCEEDED;
        state.activityLogList.data = action?.payload || [];
        state.activityLogList.pageCount = action.payload?.pageCount || 0;
      })
      .addCase(getAllActivityLogs.rejected, (state, action) => {
        state.activityLogList.status = STATUS.FAILED;
        state.activityLogList.error = action.payload?.message;
      });

    builder
      .addCase(getAllActivityLogsByUser.pending, (state) => {
        state.activityLogListByUser.status = STATUS.LOADING;
        state.activityLogListByUser.error = null;
        state.activityLogList.data = [];
      })
      .addCase(getAllActivityLogsByUser.fulfilled, (state, action) => {
        state.activityLogListByUser.status = STATUS.SUCCEEDED;
        state.activityLogListByUser.data = action?.payload || [];
        state.activityLogList.pageCount = action.payload?.pageCount || 0;
      })
      .addCase(getAllActivityLogsByUser.rejected, (state, action) => {
        state.activityLogListByUser.status = STATUS.FAILED;
        state.activityLogListByUser.error = action?.payload;
      });

    builder
      .addCase(getAllActivityLogsByCertificate.pending, (state) => {
        state.activityLogListByCertificate.status = STATUS.LOADING;
        state.activityLogListByCertificate.error = null;
      })
      .addCase(getAllActivityLogsByCertificate.fulfilled, (state, action) => {
        state.activityLogListByCertificate.status = STATUS.SUCCEEDED;
        state.activityLogListByCertificate.data = action?.payload || [];
        state.activityLogList.pageCount = action.payload?.pageCount || 0;
      })
      .addCase(getAllActivityLogsByCertificate.rejected, (state, action) => {
        state.activityLogListByCertificate.status = STATUS.FAILED;
        state.activityLogListByCertificate.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */
export const selectAllActivityLog = (state) =>
  state.activityLog.activityLogList;

export const selectAllActivityLogByUser = (state) =>
  state.activityLog.activityLogListByUser;

export const selectAllActivityLogByCertificate = (state) =>
  state.activityLog.activityLogListByCertificate;

export const { clearActivityLogs } = activityLogSlice.actions;

export default activityLogSlice.reducer;
